import request from 'superagent';
import {language} from 'helpers/stableValues';

const fetchCmsProxy = (url) => request.get(`/${language}/cms-services/cms-proxy/${url}`);

const fetchArticles = request.get(`/${language}/cms-services/faq-articles`);

const searchResults = (text, type) => request.get(
  `/${language}/cms-services/search/s=${text}&lang=${language}&type=${type}`
);

const fetchVesselInfo = (operating, mean, template) => request.get(
  `/${language}/cms-services/pages-abbr/abbr=${operating}-${mean}-${language}&template=${template}`
);

export {
  fetchCmsProxy,
  fetchArticles,
  searchResults,
  fetchVesselInfo
};
